import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import route from './modules/route'
import user from './modules/user'
import global from './modules/global'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    route,
    user,
    global,
  },
  getters
})

export default store
